import {
  Dialog,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { StyledPaper } from "../../customComponents/styled/styledPaper";
import { StyledLoadingButton } from "../../customComponents/styled/styledButtons";
import { useGraduateStudentsMutation } from "./studentApiSlice";
import toast from "../../../helpers/toast";

function GraduateStudentsDialog({
  open,
  setOpen,
  selectedStudents,
  setSelectedStudents,
  currentClassroom,
}) {
  const [graduateStudents, { isLoading }] = useGraduateStudentsMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleGraduate = async () => {
    try {
      const studentIds = selectedStudents.map((s) => s.id);
      await graduateStudents({
        student_ids: studentIds,
        classroom_id: currentClassroom,
      }).unwrap();
      toast.success(`${studentIds.length} student(s) graduated successfully`);
      setSelectedStudents([]);
      handleClose();
    } catch (error) {
      toast.error("Failed to graduate students");
      handleClose();
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
      <StyledPaper>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            pb: 1,
          }}
        >
          <Typography variant="formHeading">Graduate Students</Typography>
          <CloseSharpIcon
            onClick={handleClose}
            sx={{ cursor: "pointer" }}
          />
        </Box>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            The following students will be marked as graduated and removed from
            this class. This action can be reversed from the student's profile.
          </Typography>
          <List dense>
            {selectedStudents.map((student) => (
              <ListItem key={student.id} disableGutters>
                <ListItemText
                  primary={`${student.first_name} ${student.last_name}`}
                  secondary={student.reg_number}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <StyledLoadingButton
            variant="outlined"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </StyledLoadingButton>
          <StyledLoadingButton
            variant="contained"
            color="error"
            loading={isLoading}
            onClick={handleGraduate}
          >
            Graduate
          </StyledLoadingButton>
        </DialogActions>
      </StyledPaper>
    </Dialog>
  );
}

export default GraduateStudentsDialog;
